import React from "react";
import Tooltip from "@mui/material/Tooltip";

/**
 * 챗봇 아이콘 버튼의 풍선도움말 (2026-10-16) — 카톡 PC 처럼 같은 모양(작은 어두운 풍선) · 짧은 명사.
 * 브라우저 기본 title 은 모양 · 뜨는 시간이 제각각이라 이것으로 맞춘다.
 * 잠긴(disabled) 버튼은 마우스 이벤트가 없어 풍선이 안 뜬다 — span 으로 감싼다.
 */
export default function ChatTip({
  title,
  placement = "bottom",
  children,
}: {
  title: string;
  placement?: "bottom" | "top" | "left" | "right";
  children: React.ReactElement;
}) {
  return (
    <Tooltip
      title={title}
      placement={placement}
      enterDelay={300}
      disableInteractive
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: "rgba(30, 41, 59, 0.92)",
            borderRadius: "4px",
            fontSize: 12,
            fontWeight: 400,
            px: 1,
            py: 0.5,
          },
        },
      }}
    >
      <span style={{ display: "inline-flex" }}>{children}</span>
    </Tooltip>
  );
}
